const pro = 'https://api.hfbsoftware.com'
const dev = 'https://test.hfbsoftware.com'

const config = {}
config.host = process.env.NODE_ENV === 'production' ? pro : dev
config.mode = process.env.NODE_ENV === 'production' ? 'pro' : 'dev'


export default config


// WEBPACK FOOTER //
// ./src/Config/config.js